import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ShieldAlert, ArrowLeft } from 'lucide-react';

/**
 * Access Denied (403) screen shown when an authenticated user navigates to a
 * feature they do not have permission to view. Kept intentionally simple and
 * on-brand with the rest of the app (shadcn Card + tokens).
 *
 * @param {{ title?: string, message?: string }} props
 */
const AccessDenied = ({
  title = 'Access denied',
  message = "You don't have permission to view this page. If you believe this is a mistake, contact your workspace administrator.",
}) => {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-[60vh] items-center justify-center p-6">
      <Card className="w-full max-w-md text-center">
        <CardHeader className="items-center">
          <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-destructive/10">
            <ShieldAlert className="h-6 w-6 text-destructive" aria-hidden />
          </div>
          <CardTitle>{title}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">{message}</p>
          <div className="flex justify-center gap-2">
            <Button variant="outline" onClick={() => navigate(-1)}>
              <ArrowLeft className="mr-2 h-4 w-4" />
              Go back
            </Button>
            <Button onClick={() => navigate('/app/dashboard')}>Go to dashboard</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AccessDenied;
